import { Controller } from "@hotwired/stimulus"

// Reusable Add/Edit Address modal. Wrap a trigger + the
// account/addresses/_address_modal partial in a single
// data-controller="address-modal" element:
//
//   %span{ data: { controller: "address-modal" } }
//     = link_to "Edit", "#", data: { action: "click->address-modal#open" }
//     = render "account/addresses/address_modal", address:, url:, method:
//
// Submits via form.submit() so it works regardless of Turbo / ujs handling.
export default class extends Controller {
  static targets = [
    "modal", "form",
    "firstNameInput", "lastNameInput", "addressInput", "cityInput", "stateInput", "zipInput",
    "firstNameError", "lastNameError", "addressError", "cityError", "stateError", "zipError"
  ]

  open(event) {
    if (event) event.preventDefault()
    this.modalTarget.hidden = false
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.hidden = true
    document.body.style.overflow = ""
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  // Clear a field's error as soon as the user edits it.
  clearError(event) {
    const input = event.target
    const field = input.closest(".sa-field")
    const error = field && field.querySelector(".sa-field-err")
    if (error) error.textContent = ""
    input.classList.remove("sa-err")
  }

  // Save button (type=button): validate, then submit natively.
  submitAddress() {
    if (this._validate()) this.formTarget.submit()
  }

  // Fallback for Enter-key submits.
  validateForm(event) {
    if (!this._validate()) event.preventDefault()
  }

  _validate() {
    let valid = true
    const checks = [
      [this.firstNameInputTarget, this.firstNameErrorTarget, "First name is required"],
      [this.lastNameInputTarget, this.lastNameErrorTarget, "Last name is required"],
      [this.addressInputTarget, this.addressErrorTarget, "Address is required"],
      [this.cityInputTarget, this.cityErrorTarget, "City is required"],
      [this.stateInputTarget, this.stateErrorTarget, "State is required"],
      [this.zipInputTarget, this.zipErrorTarget, "ZIP is required"]
    ]
    checks.forEach(([input, error, msg]) => {
      if (!input.value.trim()) {
        error.textContent = msg
        input.classList.add("sa-err")
        valid = false
      } else {
        error.textContent = ""
        input.classList.remove("sa-err")
      }
    })

    const zip = this.zipInputTarget.value.trim()
    if (zip && !/^\d{5}(-\d{4})?$/.test(zip)) {
      this.zipErrorTarget.textContent = "Enter a valid ZIP (e.g. 83701)"
      this.zipInputTarget.classList.add("sa-err")
      valid = false
    }

    return valid
  }
}
